<template>
  <base-button class="btn-danger" text="削除" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'DeleteButton',
  components: {
    BaseButton,
  },
}
</script>
